import { render, staticRenderFns } from "./StokDetayComponent.vue?vue&type=template&id=3d21461b"
import script from "./StokDetayComponent.vue?vue&type=script&lang=js"
export * from "./StokDetayComponent.vue?vue&type=script&lang=js"
import style0 from "./StokDetayComponent.vue?vue&type=style&index=0&id=3d21461b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports